class localStorageService {
  ls = window.localStorage;

  removeItem = (key) => this.ls.removeItem(key);

  setItem(key, value) {
    value = JSON.stringify(value);
    this.ls.setItem(key, value);
    return true;
  }

  /**
  * Làm sạch dữ liệu sysConfig trước khi trả về.
  * Dùng để loại bỏ những key không muốn đọc từ server (ví dụ PAYMENT_METHOD_LIMITS)
  */
  sanitizeSysConfig(sysConfig) {
    if (!sysConfig || typeof sysConfig !== "object") return sysConfig;

    // Danh sách các key không được phép đọc từ server
    const blockedKeys = ["PAYMENT_METHOD_LIMITS"];

    blockedKeys.forEach((key) => {
      if (key in sysConfig) {
        console.warn(`[localStorageService] Bỏ qua key ${key} từ sysConfig`);
        delete sysConfig[key];
      }
    });

    return sysConfig;
  }

  getItem(key) {
    try {
      let value = this.ls.getItem(key);
      let parsed = JSON.parse(value);

      // ✅ Nếu key là sysConfig, thì làm sạch trước khi trả
      if (key === "sysConfig") {
        parsed = this.sanitizeSysConfig(parsed);
      }

      return parsed;
    } catch (e) {
      return null;
    }
  }

  parseJson(str, defaultValue) {
    try {
      return JSON.parse(str);
    } catch (e) {
      if (defaultValue) return defaultValue;
      // neu k co defaultValue return mac dinh
      return str;
    }
  }

  getLoginUser() {
    return this.getItem("auth_user");
  }

  getListModulesCode() {
    return this.getItem("list_modules");
  }

  getListProvince() {
    return this.getItem("list_province");
  }

  getListDistrict() {
    return this.getItem("list_district");
  }

  getListCommune() {
    return this.getItem("list_commune");
  }

  getRequestNumber() {
    return this.getItem("current_request_number");
  }
  getListRequestNumber() {
    return this.getItem("search_list_request_number");
  }
  getDefaultRoom() {
    return this.getItem("default_room");
  }
  getAdministrativePatientDetail() {
    return this.getItem("administrativePatientDetail");
  }
  getPrintFormCode() {
    return this.getItem("PRINT_FORM_CODE");
  }
  getTypeExam() {
    return this.getItem("typeExam");
  }
  getListBanks() {
    return this.getItem("listBank");
  }

  getDefaultDepartment = () => this.getItem("defaultDepartment");
}

export default new localStorageService();
